<template>
  <!-- 搜索联系人结果 -->
  <div class="bg-white z-index-1 left-0 bottom-0 right-0">
    <div style="background:#F5F5F5" class="" v-if="navSelctType == 0"></div>
    <div class="h-38 l-h-38 p-l-16 f-s-12" style="color: #999999;border-bottom: 1px solid #f2f2f2" v-if="navSelctType == 0">{{currentnavSelctType=='1'?'网点':currentnavSelctType=='2'?'我的组织':'群聊'}}</div>
    <div class="t-a-center p-x-20 l-h-24 p-y-10" v-if="noData && keyWord&&!searchedDataTeam.teamId">未搜索到 “{{keyWord}}” 的相关内容</div>
    <template v-else-if="!keyWord">
      <div class="t-a-center" style="margin: 68px auto auto;">
        <img src="@/assets/images/im/kong-order@2x.png" width="155px" height="104px"/>
      </div>
      <div class="f-s-12 t-a-center" style="color:#999999">输入关键字开始搜索</div>
    </template>
    <ul>
      <li class="d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="(item, index) in searchedData" :key="index" v-if="(navSelctType == 0 && 3 > index && currentnavSelctType==3) || (navSelctType == 3&&currentnavSelctType==3)" @click="itemClickEvent(item)">
        <div class="d-table-cell v-a-middle h-100-p w-64" v-if="item.serverCustom && item.avatar !== 'N'"  style="text-align: center;" >
          <img v-if="item.avatar" :src="item.avatar"  style="width:40px;height:40px;"/>
          <img v-else src="@/assets/images/im/zhuanShu@2x.png" style="width:40px;height:40px;"/>
        </div>
        <div class="d-table-cell v-a-middle h-100-p w-64 t-a-center" v-else>
          <img src="@/assets/images/im/team-cus.png" style="width:40px;height:40px;"/>
        </div>
        <div class="p-relative d-table-cell v-a-middle h-100-p">
          <div :style="{width:listWidth+'px'}">
            <div>
              <p class="t-ellipsis l-h-1-6-em m-r-10" v-if="item.teamNameHtmlFlag" v-html="item.teamNameHtml"></p>
              <p class="t-ellipsis l-h-1-6-em m-r-10" v-else>{{item.name}}</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <ul v-if="searchedDataTeam.teamId">
      <li class="d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover" v-if="searchedDataTeam.name"  @click="itemClickEvent(searchedDataTeam)">
        <div class="d-table-cell v-a-middle h-100-p w-64" v-if="searchedDataTeam.serverCustom && searchedDataTeam.avatar !== 'N'"  style="text-align: center;" >
          <img v-if="searchedDataTeam.avatar" :src="searchedDataTeam.avatar"  style="width:40px;height:40px;"/>
          <img v-else src="@/assets/images/im/zhuanShu@2x.png" style="width:40px;height:40px;"/>
        </div>
        <div class="d-table-cell v-a-middle h-100-p w-64 t-a-center" v-else>
          <img src="@/assets/images/im/team-cus.png" style="width:40px;height:40px;"/>
        </div>
        <div class="p-relative d-table-cell v-a-middle h-100-p">
          <div :style="{width:listWidth+'px'}">
            <div>
              <p class="t-ellipsis l-h-1-6-em m-r-10">{{searchedDataTeam.name}}</p>
            </div>
          </div>
        </div>
      </li>
     <!-- <div class="h-36 l-h-36 p-l-16 p-r-12 flex justify-content-between align-items-center" v-if="!searchedDataTeam.name&&searchedData.length">未搜索到相关公开群聊</div>-->
    </ul>
    <div class="h-36 l-h-36 p-l-16 p-r-12 flex justify-content-between align-items-center cursor-pointer" style="color: #653EB3;border-bottom: 1px solid #f2f2f2;" v-if="navSelctType == 0 && !noData && searchedData.length > 3" @click="selectedContacts"><span class="d-block">查看更多相关群</span><img src="@/assets/images/im/arrow-right@2x.png" class="d-block" style="width: 8px;height:14px"/></div>

    <!--<div class="h-36 l-h-36 p-l-16 p-r-12 flex justify-content-between align-items-center cursor-pointer" style="color: #653EB3;border-bottom: 1px solid #f2f2f2;" v-if="navSelctType == 3&&keyWord"  @click="searchNetworkTeam" ><span class="d-block">网络查找公开群聊</span><img src="@/assets/images/im/arrow-right@2x.png" class="d-block" 
    :style="{'width': '8px','height':'14px','transform':rotateFlag?'rotate(0deg)':'rotate(90deg)'}"/></div>-->

    
  </div>
</template>
<script>
import zhuanShu from '@/assets/images/im/zhuanShu@2x.png';
import teamcus from '@/assets/images/im/team-cus.png';
import {isValidByKCode} from '@/api/imInterface'
console.log(zhuanShu)
export default {
  props: {
    im: {
      type: Object,
      default: function () {
        return {}
      }
    },
    width: {
      type: Number,
      default: 250
    },
    searchTeamList: {
      type: Array,
      default: function(){
        return []
      }
    },
    searchedDataTeam: {
      type: Object,
      default: function () {
        return {}
      }
    },
    keyWord:{
      type:String,
      default: ""
    },
    navSelctType:{
      type: String,
      default: "0"
    },
    currentnavSelctType:{
      type: String,
      default: "1"
    },
  },
  data: function () {
    return {
      listWidth: 185,
      searchedData:[],
      noData: false,
      rotateFlag:true,
      // searchedDataTeam:{}
    };
  },
  components: {
    
  },
  created: function () {
    
  },
  mounted:function () {
  
  },
  computed: {
  },
  methods: {
    setColorForKeyWord(arr){
      if(this.currentnavSelctType == '3'){
        let $this = this,data = arr.concat();
        
        data.map(function(item){
          if(item.name){
            item.teamNameHtml =  item.name.replace(new RegExp('(' + $this.keyWord + ')', 'g'), '<span style="color:#653EB3">$1</span>');
            item.teamNameHtmlFlag = true;
          }
        })
       
        $this.searchedData = data;
      }

    },
    selectedContacts:function(){
      // 需要判断网点还是组织 群聊类型 数据来源也是
      this.$emit("switchTab",this.currentnavSelctType);
    },
    //获取当前登陆人所有群聊
    nimgetTeams(){
      let that = this;
      this.im.getTeams({
          done:function(error,teamlist){
            sessionStorage.setItem("teamslist"+that.$store.state.user.loginId,JSON.stringify(teamlist));
          }
        })
    },
    //校验专属kcode权限isValidByKCode
    isValidByKCodeFun(item){
      try{
        let kcode = '';
        if(item&&item.serverCustom){
          kcode = JSON.parse(item.serverCustom).kCode;
        }
        let params = {
          loginId:this.$store.state.user.loginId,
          kcode:kcode
        };
        isValidByKCode(params).then(res=>{
          if(res.status==0){
            if(res.data.isValid){
              this.applyTeam(item);
            }else{
              this.$message({message:res.data.message, type: 'warning'});
            }
          }
        }).catch(e=>{
          this.$message.error(e);
        })
      }catch(err){
        this.$message.error(err);
      }

      
    },
    //申请加入群聊
    applyTeam(item){
       let that = this;
      this.im.applyTeam({
          teamId: item.teamId,
          done: function(err, obj) {
            console.log('------',err,obj);
              if (!err) {
                if(item.joinMode=='needVerify'){
                  that.$message({
                    message: '入群需要审核，已提交入群申请！',
                    type: 'success'
                  });
                }else{
                  that.$message({
                    message: '加入群聊成功！',
                    type: 'success'
                  });          
                }

              }
          }
      });
    },
    // 点击联系人
    itemClickEvent: function (item) {
      console.log('itemClickEvent---',item);
      let  currentTeamList = sessionStorage.getItem("teamslist"+this.$store.state.user.loginId);
      currentTeamList = currentTeamList?currentTeamList:this.nimgetTeams();
      currentTeamList = JSON.parse(currentTeamList);
      if(item.isNetWorkSearch){
        let isOwnerTeam = false;
        currentTeamList.forEach(team =>{
          if(team.teamId == item.teamId){
            isOwnerTeam = true;
           
        }

          
        })
        console.log('--------------',isOwnerTeam)
        if(isOwnerTeam){
          this.$emit('createSession', item);
        }
        // else{
        //   const h = this.$createElement;
        //   this.$msgbox({
        //     title: '加入群聊',
        //     message: h('p', {
        //         style:{
        //           display:'flex',
        //           'justify-content':'flex-start',
        //           'align-items':'center'
        //       }
        //     }, [
        //     h('img', 
        //     {
        //       attrs:{
        //       src:item.serverCustom?zhuanShu:teamcus
        //     },
        //     style:{
        //       width:'40px',
        //       height:'40px'
        //     }
        //     }
        //     ),
        //     h('span', { style: 'margin-left: 7px' }, item.name)
        //     ]),
        //     showCancelButton: true,
        //     confirmButtonText: '加入群聊',
        //     cancelButtonText: '取消',
        //     beforeClose: (action, instance, done) => {
        //       done();
        //       if (action === 'confirm') {
        //         if(item.serverCustom){
        //           this.isValidByKCodeFun(item)
        //         }else{
        //           this.applyTeam(item);
        //         }
        //       }
        //     }
        //   })
        // }

      }else{
        this.$emit('createSession', item);
      }
      
    },
    // 判断是否包含中文
    isChinese(str) {
      let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
      if (reg.test(str)) return true;
      return false;
    },
    // 判断是否为数字
    isNumber(str) {
      let reg = /^\d+$/g;
      if (reg.test(str)) return true;
      return false;
    },
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
      log("width",val);
    },
    searchTeamList:{
      handler:function(arr){
        let $this = this;
        // $this.rotateFlag = true;
        // $this.searchedDataTeam = {};
        // if(this.keyWord){
        //   $this.searchNetworkTeam();
        // }
        $this.searchedData = [];
        if(arr.length == 0) {
            $this.noData = true;
            return;
        };
        $this.noData = false;
        $this.setColorForKeyWord(arr);
       
        
      },
      immediate: true
    }
  }
}
</script>